import { render, staticRenderFns } from "./BaseHeaderBox.vue?vue&type=template&id=f85cff2e&scoped=true"
import script from "./BaseHeaderBox.vue?vue&type=script&lang=js"
export * from "./BaseHeaderBox.vue?vue&type=script&lang=js"
import style0 from "./BaseHeaderBox.vue?vue&type=style&index=0&id=f85cff2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85cff2e",
  null
  
)

export default component.exports